import ctl from '@netlify/classnames-template-literals';

const inputBorderStyle = ctl(`
  border-[1px] 
  border-white
  rounded-md
  hover:border-chinese-silver
  focus:border-chinese-silver 
  active:border-chinese-silver
  outline-none 
`);

export const inputStyle = ctl(`
  w-full 
  max-w-[500px]
  font-[600]
  text-3xl 
  text-black
  pr-[15px] 
  pl-1 
  py-2
  ${inputBorderStyle}
`);

export const iconStyle = ctl(`
  text-black
  text-3xl
  cursor-pointer
`);
